
    import "src/app/AppAdmin/D2R/RecomendationEngine/index.module.scss?farm_css_modules";
    
    export default {"form": `form-f15b2b22`,"page": `page-f15b2b22`}
    